<template>
  <div class="purse-body">
    <div class="Content-subject">

      <div
        style="display: flex; width: 100%; flex: 1; min-height: 0; overflow: hidden;"
        v-if="menuList && menuList.length > 0"
      >
        <!-- 协议 右侧导航菜单 -->
        <div class="menu" v-if="Toggle == '1'">
          <p
            v-for="(item, index) in menuList"
            :key="index"
            class="menu-p"
            :class="menuSelect == item.code ? 'Select' : 'Select-Not'"
            @click="handelMenu(item)"
          >
            {{ item.name }}
          </p>
        </div>
        <div class="menu-Nav" v-else>
          <p
            v-for="(item, index) in menuList"
            :key="index"
            class="menu-p"
            :class="menuSelect == item.code ? 'Select' : 'Select-Not'"
            @click="handelMenuHistory(item)"
          >
            {{ item.name }}
          </p>
        </div>
        <!-- 协议内容 -->
        <div class="content">
          <!-- 按钮 -->
          <div class="Operating-Area" v-if="Toggle == '1'">
            <!-- <div class="Download-icon firm-clickable" @click="handelDownload" v-if="agreementList.docId">下载协议</div> -->
            <!-- <p class="Download firm-clickable" @click="handelDownload">下载</p> -->
            <div class="btn-Area">
              <p class="btn firm-clickable" @click="handelClick()">历史版本</p>
            </div>
          </div>
          <div class="Operating-Area" v-else>
            <div class="btn-Area">
              <p class="btn firm-clickable" @click="handelClickReturn">返回</p>
            </div>
          </div>
          <!-- 内容/表格 -->
          <div class="content-box">
            <agreement
              v-if="Toggle == '1' && agreementList.fullText"
              :content="agreementList"
            ></agreement>
            <div v-if="Toggle == '1' && !agreementList.fullText" style="text-align: center; padding: 50px; color: #999;">
              暂无协议数据
            </div>
            <tableA v-if="Toggle == '2'" :tableData="tableData"></tableA>
          </div>

          <!-- 底部分页 -->
          <div class="paging-box" v-if="Toggle == '2'">
            <div class="paging">
              <paging
                :pagingObj="pagingObj"
                @handleCurrentChange="handleCurrentChange"
              ></paging>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  listAgreement, // 查询协议类型列表
  findNewAgreementByCode, //根据协议code查看最新版本的协议文件信息
  listVersionAgreement, //查询协议文件历代版本列表
} from "../../../assets/api/JobInterview";
import { postGetStsDowLoadPath } from "../../../assets/api/index";
// 引入分页组件
import paging from "../../../components/paging.vue";
import agreement from "./components/agreement.vue";
import tableA from "./components/table.vue";
export default {
  data() {
    return {
      Toggle: "1", //1文字  2历史版本表格
      menuList: [], // 导航栏数据
      menuSelect: "", // 菜单选中
      pagingObj: {
        currentPage: 1, //当前页
        pageSize: 10, // 一页显示多少个
        totalDevice: 0, //用户总数
      }, // 分页
      agreementList: {}, // 协议数据列表
      list: [], // 历史版本数据 （点击菜单列表拿到对应的数据）
      tableData: [], // 表格数据 点击列表获取 (初始化都默认为协议A的数据)
      CurrentPosition: "", // 页面当前位置
      code: "", //
    };
  },
  components: { paging, agreement, tableA },
  //
  created() {
    this.listAgreement();
  },
  mounted() {
    // 路由参数处理在 listAgreement 完成后进行
  },
  methods: {
    // 点击下载（暂时注释）
    // handelDownload() {
    //   postGetStsDowLoadPath(this.agreementList.docId).then((res) => {
    //     if (res.code == 0) {
    //       let a = document.createElement("a");
    //       a.href = res.data;
    //       a.click();
    //     }
    //   });
    // },
    // 返回
    handelClickReturn() {
      this.findNewAgreementByCode();
      this.Toggle = "1";
    },
    // 点击历史版本
    handelClick() {
      var data = {
        data: {
          code: this.code,
        },
      };
      listVersionAgreement(
        data,
        this.pagingObj.currentPage,
        this.pagingObj.pageSize
      ).then((res) => {
        this.tableData = res.data.list;
        this.pagingObj.totalDevice = res.data.total;
      });
      this.Toggle = "2";
    },
    // -----------------------根据协议code查看最新版本的协议文件信息-------------
    async findNewAgreementByCode() {
      var data = {
        data: {
          code: this.code,
        },
      };
      console.log('findNewAgreementByCode request:', data);
      const res = await findNewAgreementByCode(data);
      console.log('findNewAgreementByCode response:', res);
      if (res.data) {
        this.agreementList = res.data;
        console.log('agreementList:', this.agreementList);
      } else {
        var data = {
          name: "暂无数据",
          createTime: "",
          version: "",
        };
        this.agreementList = data;
        console.log('No data, set default agreementList:', this.agreementList);
      }
    },
    // -----------------------查询协议类型列表-------------
    async listAgreement() {
      var data = {
        data: {},
      };
      const res = await listAgreement(data);
      console.log('listAgreement response:', res);
      this.menuList = res.data;
      console.log('menuList:', this.menuList);
      // 获取到菜单列表后，根据路由参数选择对应协议或默认选择第一个
      if (this.menuList && this.menuList.length > 0) {
        // 检查是否有路由参数指定协议名称
        if (this.$route.query.name) {
          const targetName = this.$route.query.name;
          const targetItem = this.menuList.find(item => item.name === targetName);
          if (targetItem) {
            this.CurrentPosition = targetItem.name;
            this.code = targetItem.code;
            this.menuSelect = targetItem.code;
            this.findNewAgreementByCode();
          } else {
            // 未找到对应协议，默认选择第一个
            this.CurrentPosition = this.menuList[0].name;
            this.code = this.menuList[0].code;
            this.menuSelect = this.menuList[0].code;
            this.findNewAgreementByCode();
          }
        } else {
          // 没有路由参数，默认选择第一个
          this.CurrentPosition = this.menuList[0].name;
          this.code = this.menuList[0].code;
          this.menuSelect = this.menuList[0].code;
          this.findNewAgreementByCode();
        }
      } else {
        console.log('menuList is empty or null');
      }
    },
    // 导航点击切换
    handelMenu(item) {
      this.CurrentPosition = item.name;
      this.code = item.code;
      this.findNewAgreementByCode();

      this.menuSelect = item.code;
    },
    //历史记录中导航切换
    handelMenuHistory(item) {
      this.CurrentPosition = item.name;
      this.code = item.code;
      this.handelClick();
      this.menuSelect = item.code;
    },
    // 分页
    handleCurrentChange(num) {
      // num 要跳转的页面
      this.pagingObj.currentPage = num;
      this.handelClick();
    },
  },
};
</script>

<style scoped lang="less">
// 最外层div
.purse-body {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
  // 内容主体
  .Content-subject {
    width: 100%;
    flex: 1;
    min-height: 0;
    background: #ffffff;
    box-shadow: 0px 0px 3px 0px rgba(125, 125, 125, 0.5);
    border-radius: 5px;
    padding: 0 30px;
    box-sizing: border-box;
    display: flex;
    overflow: hidden;
    // 协议文导航菜单
    .menu {
      width: 160px;
      flex-shrink: 0;
      overflow-y: auto;
      background: #eeeeee;
      border-radius: 10px 0px 0px 0px;
      padding: 10px 10px 0px 10px;
      background: #ffffff;
      border-right: 1px solid #eeeeee;
    }
    .menu-p {
      width: 100%;
      height: 40px;
      line-height: 40px;
      border-radius: 10px 0px 0px 10px;
      font-size: 14px;
      color: #333333;
      text-align: center;
      margin-bottom: 10px;
      cursor: pointer;
    }
    .Select {
      background: #ffffff;
      color: #409eff ;
      background: #ecf1ff;
      border-radius: 6px 6px 6px 6px;
    }
    // 协议列表导航菜单
    .menu-Nav {
      width: 160px;
      max-height: 500px;
      overflow-y: auto;
      background: #eeeeee;
      border-radius: 10px 0px 0px 10px;
      margin-bottom: auto;
      margin-top: 20px;
      // margin-left: 20px;
      padding: 10px 10px 0px 10px;
      background: #ffffff;
      box-shadow: 1px 2px 5px 0px rgba(0, 0, 0, 0.08);
      border-radius: 5px 5px 5px 5px;
    }
    // 协议文内容
    .content {
      flex: 1;
      min-width: 0;
      min-height: 0;
      margin-left: 20px;
      padding-top: 15px;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      // border: 1px solid gold;
      .Operating-Area {
        width: 100%;
        height: 30px;
        margin-bottom: 5px;
        flex-shrink: 0;
        display: flex;
        p {
          cursor: pointer;
        }
        // 下载icon样式
        .Download-icon {
          // width: 20px;
          // height: 20px;
          // margin: auto 0;
          // background-image: url("../../../../assets/imgs/xiazai@3x.svg");
          // background-size: 100% 100%;
          width: 90px;
          height: 30px;
          line-height: 30px;
          background: #409eff;
          border-radius: 5px;
          cursor: pointer;
          font-family: Microsoft YaHei, Microsoft YaHei;
          font-weight: 400;
          font-size: 14px;
          color: #ffffff;
          text-align: center;
          font-style: normal;
          text-transform: none;
        }
        .Download {
          line-height: 30px;
          font-family: PingFangSC-Medium;
          font-size: 12px;
          color: #333333;
          font-weight: 400;
          margin-left: 5px;
        }
        .btn-Area {
          flex: 1;
          height: 30px;
          display: flex;
          justify-content: flex-end;
          .btn {
            width: 90px;
            height: 30px;
            line-height: 30px;
            border: 1px solid #409eff;
            border-radius: 5px;
            cursor: pointer;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 14px;
            color: #409eff;
            text-align: center;
            font-style: normal;
            text-transform: none;
          }
        }
      }
      // 内容/文字/表格box
      .content-box {
        // border: 1px solid gold;
        min-width: 0;
        flex: 1;
        min-height: 0;
        overflow-x: hidden;
        overflow-y: auto;
        padding-bottom: 24px;
        box-sizing: border-box;
      }
    }
  }
}
// 分页
.paging-box {
  width: 100%;
  height: 22px;
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
  .paging {
    width: 90%;
    height: 100%;
    display: flex;
    justify-content: flex-end;
  }
}
</style>
